/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'presentation': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3.75 2A.25.25 0 014 1.75h16a.25.25 0 01.25.25v14a.25.25 0 01-.25.25H4a.25.25 0 01-.25-.25V2zM4 .25A1.75 1.75 0 002.25 2v14c0 .966.784 1.75 1.75 1.75h7.25v1.668a1.75 1.75 0 101.5 0V17.75H20A1.75 1.75 0 0021.75 16V2A1.75 1.75 0 0020 .25H4zm6.335 5.08A.75.75 0 009.25 6v5a.75.75 0 001.085.67l5-2.5a.75.75 0 000-1.34l-5-2.5zm2.988 3.17L10.75 9.786V7.214L13.323 8.5zM12 20.75a.25.25 0 100 .5.25.25 0 000-.5z" _fill="#000"/>'
  }
})
